module.exports = __webpack_public_path__ + "static/media/login-background.d8067536.png";